module.exports = __webpack_public_path__ + "static/media/12.d2878f31.jpg";